export const debounce = (callBack, delay = 1000) => {
    let timeout // Move timeout inside the closure - each debounced function gets its own
    const debounced = (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => callBack(...args), delay)
    }
    debounced.cancel = () => {
        clearTimeout(timeout)
    }
    return debounced
}

